import { Component, Inject, OnInit, OnDestroy, HostListener } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef, MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { LoginResponseModel } from 'app/model/login/login-response.model';
import { CompanyFeaturesDetail } from 'app/model/menu/companyFeatures';
import { UserModel } from 'app/model/user.model';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { DialogAlertComponent } from 'app/components/modal/dialog-alert/dialog-alert.component';
import { Subscription } from 'rxjs';
import { AuthorizeService } from 'app/services/authorize/authorize.service';
import { NoticeService } from 'app/services/notice/notice.service';
@Component({
  selector: 'act-dialog-switch-company',
  templateUrl: './dialog-switch-company.component.html',
  styleUrls: ['./dialog-switch-company.component.scss']
})

export class DialogSwitchCompanyComponent implements OnInit, OnDestroy {
  public setElementIdPage = 'dialog-switch-company';
  public user: UserModel;
  public isLoading: boolean;
  public lang: string;
  private authServiceSubscription: Subscription;
  public travelPolicyCoBudgetList = [];

  constructor(
    private dialogRef: MdDialogRef<DialogSwitchCompanyComponent>,
    private appConfigService: AppConfigService,
    private authService: AuthenticationService,
    private authorizeService: AuthorizeService,
    private router: Router,
    private dialog: MdDialog,
    private noticeService: NoticeService,
    @Inject(MD_DIALOG_DATA) public data: CompanyFeaturesDetail,
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    document.documentElement.style.setProperty('--height-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.onResize();
    this.user = this.authService.getUserInfo();
    this.lang = this.getLang();
    if (this.data && this.data.travelPolicyList !== null) {
      for (var travelPolicy of this.data.travelPolicyList) {
        if (travelPolicy.coBudgetUnlimited != null) {
          this.travelPolicyCoBudgetList.push(travelPolicy);
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
  }

  onChangeCompany() {
    this.isLoading = true;
    const user = new UserModel;
    user.companyId = this.data.companyId;

    const loginResponseModel = new LoginResponseModel;
    this.user.companyId = this.data.companyId;
    this.user.companyTitleTh = this.data.companyTitleTh;
    this.user.companyTitleEn = this.data.companyTitleEn;
    loginResponseModel.user = this.user;

    this.noticeService.removeNotifyCookie();
    this.authorizeService.removeCoBookerCookie();
    this.authServiceSubscription && this.authServiceSubscription.unsubscribe();
    this.authServiceSubscription = this.authService.saveUserFeature(null, user, AuthenticationService.features).subscribe(save => {
      save && this.authService.saveToken(loginResponseModel);
      this.dialogRef.close('success');
      if (document.location.pathname === '/checkout') {
        this.router.navigateByUrl('/?lang=' + this.appConfigService.getLanguage());
      } else {
        // Reload current router
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
          return false;
        };
        this.router.navigated = false;
        this.router.navigateByUrl(this.router.url);
      }
    }), error => {
      this.dialogRef.close();
      const dialogAlertRef: MdDialogRef<DialogAlertComponent> = this.dialog.open(DialogAlertComponent);
      dialogAlertRef.componentInstance.alertText = this.appConfigService.getTranslate('system-error');
      dialogAlertRef.componentInstance.imageSrc = '/assets/images/icons/icon-failed.png';
      dialogAlertRef.componentInstance.imageSrcSet = '/assets/images/icons/icon-failed.png';
    };
  }

  getLang() {
    return this.appConfigService.getLanguage();
  }

  onClose() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/menu-bar/dialog-switch-company/dialog-switch-company.component.ts